import { useEffect, useState } from 'react';
import { PaginationConfigProps } from '../types';

export function usePaginationState(paginationConfig: PaginationConfigProps) {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(paginationConfig.pageSize);

  useEffect(() => {
    setPageSize(paginationConfig.pageSize);
  }, [paginationConfig.pageSize]);

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPageIndex(0);
  };

  return {
    pageIndex,
    setPageIndex,
    pageSize,
    setPageSize,
    handlePageSizeChange,
  } as const;
}
